import * as api from './index';
const t = '/statistics';

export default {
  get: api.get(`${t}/users/birthday`),
  getHired: api.get(`${t}/users/hired`),
  getTrial: api.get(`${t}/users/trial`),
};